import React from 'react';
import "./Dialog.css";

function Dialog({ children, onClose, showDialog, setShowDialog }) {
	const closeDialog = () => {
		onClose();
	};

	return (
		<>
			<dialog open={showDialog}>
				<button className="close-btn" onClick={closeDialog}>&times;</button>
				<div className="dialog-body">
					{children && React.cloneElement(children, { showDialog, setShowDialog })}
				</div>
			</dialog>
			{ showDialog
				? <div className="backdrop"></div>
				: <></>
			}
		</>
	);
}

export default Dialog;
